/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import PropTypes from 'prop-types';

import { Link, Modal, Paragraph, THEME_CONSTANTS } from '@cof/plastic-components';

import { withText } from '../../../text/textStore';
import ModalLink from '../../ModalLink/ModalLink';
import TermsAndConditionsModalView from '../../TermsAndConditionsModalView';
import OfferTermsAndConditionsModalView from '../../TermsAndConditionsModalView/OfferTermsAndConditionsModalView';

const { FONT_WEIGHTS } = THEME_CONSTANTS;

const TermsAndConditions = ({
    JsxText,
    Text,
    Text: text,
    path,
    tAndcPath,
    modalPath,
    id,
    modalSize,
    className,
    variant = 'dark'
}: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const onClick = () => {
        setIsOpen(true);
    };
    const modalWrapperProps = {
        width: modalSize === 'fullSize' ? '95%' : undefined,
        margin: modalSize === 'fullSize' ? undefined : '16px'
    };
    const TermsAndConditionsParams = {
        TERMS_AND_CONDITIONS: (
            <>
                {/* @ts-expect-error TS2322: Type ' children: any; onClick: () => void; modalName: any; "aria-label": string; variant: any; "data */}
                <ModalLink
                    onClick={onClick}
                    modalName={text({ path: tAndcPath })}
                    aria-label={`${text({ path: 'TermsAndConditionsHeader' })}`}
                    variant={variant}
                    data-qm-allow
                >
                    {text({ path: tAndcPath })}
                </ModalLink>
                <Modal
                    rootId="root"
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    id="t-and-c"
                    modalWrapperProps={modalWrapperProps}
                    // @ts-expect-error TS2322: Type ' children: Element; rootId: string; isOpen: boolean; onClose: () => void; id: string; modalWra
                    variant={variant}
                >
                    {modalPath === 'OfferText' ? <OfferTermsAndConditionsModalView /> : <TermsAndConditionsModalView />}
                </Modal>
            </>
        ),
        PRIVACY_POLICY: (
            <Link
                fontWeight={FONT_WEIGHTS.SB}
                external
                // @ts-expect-error TS2322: Type ' children: Element; fontWeight: FONT_WEIGHTS.SB; external: true; qaId: string; href: any; vari
                qaId="privacy-policy"
                href={text({ path: 'PrivacyPolicyLink' })}
                variant={variant}
                data-qm-allow
            >
                <span data-qm-allow>
                    <Text path="PrivacyPolicy" />
                </span>
            </Link>
        )
    };
    return (
        <Paragraph data-qa-id={id} className={className} variant={variant} mt={'sm'} data-qm-allow>
            <JsxText path={path} params={TermsAndConditionsParams} />
        </Paragraph>
    );
};

TermsAndConditions.propTypes = {
    JsxText: PropTypes.func.isRequired,
    Text: PropTypes.func.isRequired,
    modalSize: PropTypes.string,
    path: PropTypes.string.isRequired,
    tAndcPath: PropTypes.string.isRequired,
    modalPath: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    variant: PropTypes.string
};

export default withText('TermsAndConditions')(TermsAndConditions);
